module.exports = __webpack_public_path__ + "front/img/c13.9e9ee90f.png";